import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client';
import { del, get, set } from 'idb-keyval';

import { tryReportError } from '../bugsnag';

export function createIDBPersister(idbValidKey: IDBValidKey = 'reactQuery') {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(idbValidKey, client);
    },
    restoreClient: async () => {
      return await get<PersistedClient>(idbValidKey);
    },
    removeClient: async () => {
      await del(idbValidKey);
    },
  } as Persister;
}

const queryCache = new QueryCache({
  onError: (_error, q) => {
    if (q.meta?.omitErrorReport) {
      return;
    }

    const errString = `error at query: ${JSON.stringify(q.queryKey)}`;
    tryReportError(_error, errString, q.meta?.type);
  },
});
const mutationCache = new MutationCache({
  onError(e, variables, _, mutation) {
    console.debug('mutation error', { e, variables, mutation });
    let errString = '';
    try {
      errString = `error at mutation: ${JSON.stringify({
        mutationKey: mutation.options.mutationKey,
        variables,
      })}`;
    } catch {
      errString = 'error at mutation (stringify error)';
    }
    tryReportError(e, errString, mutation.meta?.type);
  },
});
export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      retry: (failCount) => failCount < 1,
      refetchOnWindowFocus: true,
    },
  },
});